import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }
    const formData = new FormData(form);
    try {
      const res = await fetch('http://shlvtian.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查网络后重试');
      setStatus('error');
    }
  };

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-10">
            <div className="md:col-span-5">
              <Link to="/" className="inline-flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-fire-fill text-2xl text-primary-400"></i>
                </div>
                <span className="text-xl font-bold font-heading">51吃瓜app</span>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed mb-6 max-w-md">
                全网最火爆的娱乐资讯平台，汇聚最新最热的明星爆料、网红黑料、聊天记录泄露等吃瓜内容。每日大赛不停，让你吃到最新鲜的瓜。
              </p>
              <div>
                <p className="text-xs text-foreground-400 mb-3 uppercase tracking-wider">订阅最新爆料</p>
                <form
                  onSubmit={handleSubmit}
                 
                  id="newsletter-form"
                  className="flex flex-col sm:flex-row gap-2 max-w-sm"
                >
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入邮箱接收最新爆料"
                    required
                    className="flex-1 px-4 py-2.5 text-sm bg-foreground-800 border border-foreground-700 rounded-full text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
                  />
                  <button
                    type="submit"
                    className="px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    订阅
                  </button>
                </form>
                {status === 'success' && (
                  <p className="text-xs text-accent-400 mt-2">订阅成功！最新爆料将第一时间发送到您的邮箱。</p>
                )}
                {status === 'error' && (
                  <p className="text-xs text-primary-400 mt-2">{errorMsg}</p>
                )}
              </div>
            </div>

            <div className="md:col-span-3">
              <p className="text-xs text-foreground-400 mb-4 uppercase tracking-wider">快速导航</p>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 decoration-foreground-700 hover:decoration-primary-500">首页</Link>
                <Link to="/category/star-gossip" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 decoration-foreground-700 hover:decoration-primary-500">明星爆料</Link>
                <Link to="/category/influencer-drama" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 decoration-foreground-700 hover:decoration-primary-500">网红黑料</Link>
                <Link to="/category/chat-leaks" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 decoration-foreground-700 hover:decoration-primary-500">聊天记录</Link>
                <Link to="/category/daily-contest" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 decoration-foreground-700 hover:decoration-primary-500">每日大赛</Link>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 decoration-foreground-700 hover:decoration-primary-500">关于我们</Link>
              </div>
            </div>

            <div className="md:col-span-4">
              <p className="text-xs text-foreground-400 mb-4 uppercase tracking-wider">联系我们</p>
              <div className="flex flex-col gap-3 text-sm text-foreground-300">
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-foreground-500"></i>
                  </div>
                  <span>hello@shlvtian.cn</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-foreground-500"></i>
                  </div>
                  <span>400-888-5151</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-foreground-500"></i>
                  </div>
                  <span>北京市朝阳区望京科技园区A座15层</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4 cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center inline mr-1">
                  <i className="ri-wechat-line"></i>
                </div>
                微信
              </a>
              <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4 cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center inline mr-1">
                  <i className="ri-weibo-line"></i>
                </div>
                微博
              </a>
              <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4 cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center inline mr-1">
                  <i className="ri-bilibili-line"></i>
                </div>
                B站
              </a>
            </div>

            <p className="text-xs text-foreground-500">
              &copy; 2026 51吃瓜app 版权所有
            </p>

            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors underline underline-offset-4 cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors underline underline-offset-4 cursor-pointer">用户协议</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}